// eslint-disable-next-line import/prefer-default-export
export const LOAD_CONSTANTS = 'LOAD_CONSTANTS';
